import type { FC } from "react";
import { Box, type BoxProps } from "@hightouch/htui";
import { DEFAULT_CARD_PADDING } from "./constants";

export type CardDividerProps = Omit<BoxProps, "mx" | "borderTop">;

/**
 * A full-bleed divider for use inside Card components.
 * Extends edge-to-edge by using negative margins to counteract the card's padding.
 */
export const CardDivider: FC<CardDividerProps> = (props) => {
  return (
    <Box
      mx={-DEFAULT_CARD_PADDING}
      borderTopWidth="hairline"
      borderTopStyle="solid"
      borderColor="base.border"
      {...props}
    />
  );
};
